import EqualizerIcon from "@mui/icons-material/Equalizer";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import { Box } from "@mui/material";
import React, { useMemo } from "react";
import {
	Menu,
	useGetIdentity,
	usePermissions,
	useTranslate,
} from "react-admin";
import { DebateMenu } from "./debate";
import { ModerationMenu } from "./moderation";
import { ParliamentMenu } from "./parliament";
import { SocialNetworksMenu } from "./social_networks";
import { SourceMenu } from "./source";

const MyMenu = () => {
	const { permissions } = usePermissions();
	const { identity } = useGetIdentity();
	const modules = identity?.settings?.modules || {};
	const value = useMemo(
		() => ({
			isDebateSpaceActive: modules.debateSpace !== false,
			isParliamentActive: modules.parliament === true,
			isSocialModerationActive: modules.socialModeration === true,
			isSourceActive: modules.sources !== false,
		}),
		[modules],
	);

	const translate = useTranslate();

	return (
		<Box
			sx={{
				marginTop: 2,
				marginBottom: 2,
			}}
		>
			{identity?.settings?.modules && (
				<>
					<Menu.DashboardItem
						leftIcon={<EqualizerIcon />}
						primaryText={translate("pos.menu.dashboard")}
					/>
					{value.isDebateSpaceActive && <DebateMenu />}

					{value.isParliamentActive && <ParliamentMenu />}

					{value.isDebateSpaceActive && (
						<Menu.ResourceItem
							name="users"
							primaryText={translate("resources.users.name", {
								smart_count: 2,
							})}
						/>
					)}

					{value.isSourceActive && permissions !== "moderator" && (
						<SourceMenu />
					)}

					{value.isSocialModerationActive && <SocialNetworksMenu />}

					{(value.isDebateSpaceActive || value.isSocialModerationActive) && (
						<ModerationMenu />
					)}

					{(permissions === "admin" || permissions === "super_admin") 
						&& !value.isParliamentActive && (
						<Menu.ResourceItem
							name="settings"
							primaryText={translate("resources.settings.name", {
								smart_count: 2,
							})}
						/>
					)}
					{(value.isDebateSpaceActive || value.isSourceActive) && (
						<Menu.Item
							to="https://docs.logora.fr/"
							primaryText={translate("pos.menu.documentation")}
							leftIcon={<FindInPageIcon />}
							onClick={(e) => {
								e.preventDefault();
								window.open("https://docs.logora.fr/");
							}}
						/>
					)}
				</>
			)}
		</Box>
	);
};

export default MyMenu;
